import { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Skeleton } from "@mui/material";
import { report } from "../../features/reports/reportsSlice";
import { TitleWSelect, InfoTotal } from "../Tools";
import { getYears } from "../Tools/functions";

const initialState = { areas: [], types: [], total: 0 }

const ReportSix = () => {
    const { isLoading } = useSelector(state => state.progress);
    const [data, setData] = useState(initialState)
    const [status, setStatus] = useState('idle');
    const dispatch = useDispatch();
    const [year, setYear] = useState('');
    const options = useMemo(() => getYears(), [])

    const handleChange = (e) => {
        setYear(e.target.value)
        if(e.target.value !== ''){
            report(`six/year/${e.target.value}`, dispatch, setData, setStatus)
        }else{
            setStatus('idle')
            setData(initialState);
        }
    }
    return(
        <Container component={Paper} sx={{ p: '2em', mb: '2em' }} maxWidth='xl'>
            <TitleWSelect title={'REPORTE GENERAL EVENTOS POR ÁREA'} handleChange={handleChange} options={options} year={year} />
            { status === 'succeeded' && <InfoTotal num={data.total} /> }
            { isLoading ? <Skeleton animation='wave' height={200} /> : ( data.total ? (
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Clave</TableCell>
                                { data.types.length ? data.types.map((t, i) => <TableCell key={i} align="center" sx={{ fontSize: '0.6em' }}>{t?.nombre}</TableCell>) : null }
                                <TableCell align="center">Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { data.areas.map(({ clave, eventos, total }, i) => (
                                <TableRow key={i}>
                                    <TableCell>{clave}</TableCell>
                                    {eventos.map((e, i) => <TableCell key={i} align="center">{e.total}</TableCell>)}
                                    <TableCell align="center"><b>{total}</b></TableCell>
                                </TableRow>
                            )) }
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">TOTAL</TableCell>
                                { data.types.length ? data.types.map((t, i) => <TableCell key={i} align="center"><b>{t?.total}</b></TableCell>) : null }
                                <TableCell align="center"><b>{data.total}</b></TableCell>
                            </TableRow>
                        </TableHead>
                    </Table>
                </TableContainer>
            ) : null )}
        </Container>
    )
}

export default ReportSix;